"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var pp_react_1 = require("@paypalcorp/pp-react");
var ClassLib = require("classnames");
function FlowBody(_a) {
    var content = _a.content, _b = _a.fpti, fpti = _b === void 0 ? {} : _b, cancelUrl = _a.cancelUrl, header = _a.header, isCloseXHidden = _a.isCloseXHidden, isBackHidden = _a.isBackHidden, children = _a.children, transitionOutHandler = _a.transitionOutHandler, backButtonHandler = _a.backButtonHandler, hideBackButtonHandler = _a.hideBackButtonHandler, route = _a.route, ui = _a.ui, showNavigation = _a.showNavigation, features = _a.features;
    function handleClick(e) {
        if (backButtonHandler && backButtonHandler()) {
            return;
        }
        window.history.go(-1);
    }
    var closeTag = cancelUrl ? (React.createElement("a", { href: cancelUrl, "data-name": fpti.modalClose, className: "vx_modal-dismiss_x noPadding", onClick: function () { return transitionOutHandler && transitionOutHandler(); } },
        React.createElement("span", { className: "vx_a11yText" }, content.common.close))) : (React.createElement("a", { onClick: handleClick, className: "vx_modal-dismiss_x noPadding" },
        React.createElement("span", { className: "vx_a11yText" }, content.common.close)));
    var back = (React.createElement(pp_react_1.Button, { className: "ppvx_btn backButton", onClick: handleClick, "data-name": fpti.backButton, dir: "auto", tabIndex: 0 },
        React.createElement(pp_react_1.Icon, { name: "arrow-left", size: "sm", className: "backArrow" }),
        " ",
        content.common.back));
    var hideBackButtonForFlow = (hideBackButtonHandler && hideBackButtonHandler()) || false;
    var modalContentClass = showNavigation
        ? "vx_modal-content padding-20 "
        : "vx_modal-content noPadding";
    var isCookiePrefs = children &&
        children.type &&
        children.type.displayName === "Connect(CookiePrefs)";
    var wrapperClassName = ClassLib("vx_modal-wrapper", {
        cookiePrefsModal: isCookiePrefs,
    });
    return (React.createElement("div", { className: wrapperClassName },
        showNavigation && (React.createElement("div", { className: ui.showSpinner
                ? "modal-header clickDisabled"
                : "modal-header" },
            !isBackHidden && !hideBackButtonForFlow && back,
            !isCloseXHidden && closeTag)),
        React.createElement("div", { className: modalContentClass },
            React.createElement("main", null,
                React.createElement("header", { className: "vx_modal-header" }, header && header.__html ? (React.createElement("h2", { id: "js_modalHeader", className: "vx_h2", dangerouslySetInnerHTML: header })) : (React.createElement("h2", { id: "js_modalHeader", className: "vx_h2" }, header))),
                React.createElement("div", { className: "vx_modal-body vx_blocks-for-mobile" }, children)))));
}
var mapStateToProps = function (_a) {
    var content = _a.content, fpti = _a.fpti;
    return ({ content: content, fpti: fpti });
};
exports.default = react_redux_1.connect(mapStateToProps)(FlowBody);
